import React, { useEffect, useState } from "react"
import Carousel from 'react-bootstrap/Carousel'
import axios from "axios";
import ReactKrishViewerBasic from "../../helper/ReactKrishViewerBasic";
import { NavLink } from "react-router-dom";
import { Tooltip as ReactTooltip } from 'react-tooltip'

const Overview = () => {
    const [overLay, setOverLay] = useState(true);

    return (
        <>
            <div className="overviewMainPage">
                <ReactKrishViewerBasic
                    amount={360}
                    imagePath="assets/images/overview"
                    fileName="Overview_{index}.jpg"
                    spinReverse
                />
                {
                    overLay ?
                        <div className="overviewOverlay">
                            <div className="container-fluid overview_detail">
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="cubedots_image">
                                            <img src="/assets/images/newui/cubedots_logo.png" className="img-fluid" />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="location_data">
                                            <NavLink to="/location">
                                                <div className="location_box">
                                                    <img src="/assets/images/1.png" className="img-fluid overview_boximage" />
                                                    <div className="location_detail">
                                                        <h3>Location</h3>
                                                        <p>Discover nearby landmarks, along with their distances and estimated travel times, in relation to the project location.</p>
                                                        <button>
                                                            <NavLink to="/location" className="nav-link navbarMenu" >Click to Interact</NavLink>
                                                            <img src="/assets/images/arrow.svg" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </NavLink>
                                            <NavLink to="/virtualtour">
                                                <div className="location_box" style={{ marginLeft: "70px" }}>
                                                    <img src="/assets/images/gallery/interior/01.jpg" className="img-fluid overview_boximage" />
                                                    <div className="location_detail">
                                                        <h3>Virtual Tour</h3>
                                                        <div className="d-flex">
                                                            <ul>
                                                                <li style={{ marginTop: "10px" }}>- Interior </li>
                                                                <li style={{ marginTop: "10px" }}>- Exterior</li>
                                                            </ul>
                                                        </div>
                                                        <button>
                                                            <NavLink to="/virtualtour" className="nav-link navbarMenu" >Click to Interact</NavLink>
                                                            <img src="/assets/images/arrow.svg" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </NavLink>
                                            <NavLink to="/navigator">
                                                <div className="location_box">
                                                    <img src="/assets/images/gallery/exterior/06.jpg" className="img-fluid overview_boximage" />
                                                    <div className="location_detail">
                                                        <h3>Navigator</h3>
                                                        <p>Green City is made up of 16 blocks with 305 apartments.
                                                            305 available units.
                                                            Ground + 4 Floors.
                                                        </p>
                                                        <p>2 & 3 Bedroom Apartments</p>

                                                        <button>
                                                            <NavLink to="/navigator" className="nav-link navbarMenu" >Click to Interact</NavLink>
                                                            <img src="/assets/images/arrow.svg" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </NavLink>
                                        </div>
                                    </div>
                                    <div className="col-md-5">
                                        <div className="overview_detail_box">
                                            <div className="mb-3 d-flex align-items-center justify-content-between">
                                            <h3>Green Plaza</h3>
                                                <button className="overViewClose" onClick={() => { setOverLay(false) }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#000" className="bi bi-x" viewBox="0 0 16 16">
                                                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                                    </svg>
                                                </button>
                                            </div>
                                            <img src="/assets/images/gallery/exterior/03.jpg" className="img-fluid" />
                                            <div className="overview_description">
                                                <p>TESLA Developments is one of the leading private real estate development companies in October Gardens & Obour City. We specialize in project planning, urban development and implementation of distinguished residential and commercial real estate projects under the leadership of a group of senior Egyptian investors, consultants and engineers specialized in contracting and project management. The company owns production tools And the latest equipment and technologies used in the construction and building sector, and we have a full workforce that is always able to develop a unique and distinctive real estate product that suits the requirements of our customers and guarantees their satisfaction.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div data-tooltip-id="my-tooltip-3" onClick={() => { setOverLay(true) }} style={{ position: "fixed", top: "10px", right: "10px", color: '#FFF', backgroundColor: "#EA611D", padding: "5px 10px", cursor: "pointer", borderRadius: "5px" }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-info-circle" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                            </svg>
                        </div>
                }
                <ReactTooltip
                    id="my-tooltip-3"
                    place="right"
                    variant="info"
                    content="Info"
                />
            </div>
        </>
    )
}
export default Overview;
